import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppBtn',
    props: {
        icon: String,
        btnColor: String,
        isSmall: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: 'More'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        class: {
            type: String
        },
        minWidth: {
            type: String,
            default: '84'
        },
        loading: {
            type: Boolean,
            required: false
        }
    },
    emits: ['click'],
    setup(__props, { emit }) {
        const componentProps = __props;
        const button = computed(() => {
            return componentProps.isSmall
                ? {
                    color: componentProps.btnColor ? componentProps.btnColor : 'textPrimary',
                    size: 'x-small',
                    rounded: 'pill',
                    minWidth: componentProps.minWidth
                }
                : {
                    color: componentProps.btnColor ? componentProps.btnColor : 'secondary',
                    size: 'default',
                    rounded: 'pill',
                    minWidth: componentProps.minWidth
                };
        });
        const btnClick = () => {
            emit('click');
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_hover = _resolveComponent("v-hover");
            return (_openBlock(), _createBlock(_component_v_hover, {
                disabled: componentProps.disabled
            }, {
                default: _withCtx(({ isHovering, props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                        color: _unref(button).color,
                        variant: __props.isSmall && !isHovering ? 'outlined' : 'flat',
                        size: _unref(button).size,
                        rounded: _unref(button).rounded,
                        "min-width": _unref(button).minWidth,
                        disabled: componentProps.disabled,
                        height: __props.isSmall ? '24px' : '40px',
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (btnClick()), ["stop"])),
                        loading: componentProps.loading,
                        class: [__props.isSmall ? 'small-button px-3' : 'large-button px-3', componentProps.class, 'text-button']
                    }), {
                        default: _withCtx(() => [
                            (componentProps.icon && !__props.isSmall)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "mr-2"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(componentProps.icon), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(componentProps.text) + " ", 1),
                            (componentProps.icon && __props.isSmall)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    class: "ml-2"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(componentProps.icon), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _: 2
                    }, 1040, ["color", "variant", "size", "rounded", "min-width", "disabled", "height", "loading", "class"])
                ]),
                _: 1
            }, 8, ["disabled"]));
        };
    }
});
